module.exports = __webpack_public_path__ + "static/media/C20-0173_2.50_Mama_Burger_Desktop_2396x1473.1da1003c.jpg";